<div>
    <div class="row pb-2">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary" (click)="add(0)" [disabled]="isDisabled">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Role':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Role Master
        </div>
        <div class="card-body p-1">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered pt-2">
                <thead class="table-light">
                    <tr>
                                                <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>

                        <th>Role Name</th>
                    </tr>

                </thead>
                <tbody>

                    <tr *ngFor="let element of RoleData">
                         <td style="width: 5px;">
                            <div class="text-center" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}"><i (click)="add(element['WebESSRoleMasterID'])"
                                    class="bi bi-pencil-square text-warning"></i></div>
                        </td>
                        <td> {{element['RoleName']}}</td>
                    </tr>
                </tbody>

            </table>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">

                    <div class="row">
                    </div>
                    <div class="row">
                    </div>
                </div>
                <div class="col-auto">
                    <button  *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample" (click)="exportToExcel()">
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>